import React from 'react';
import { NavLink } from 'react-router-dom';
import { InternalRoutes } from '../../../../enum/InternalRoutes';
import { CustomImageHandler } from '../../../components/CustomImageHandler';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FavoriteCampaign } from '../../../../model/campaign/FavoriteCampaign';

interface ICampaignLink {
    campaign: FavoriteCampaign;
}

export default function CampaignLink({ campaign }: ICampaignLink) {
    return (
        <NavLink to={InternalRoutes.BRAND_CAMPAIGN + '/dashboard/' + campaign.id} className="campaign-link">
            <OverlayTrigger
                placement="right"
                overlay={<Tooltip id={`camp-tooltip-${campaign.id}`}>{campaign.title}</Tooltip>}
            >
                <div className="sidebar-image">
                    <CustomImageHandler
                        thumbnailPath={campaign?.campaignImages?.[0]?.thumbnail}
                        photoPath={
                            campaign?.campaignImages?.[0]?.thumbnail ??
                            'https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg'
                        }
                        classes="icon"
                        altTag={campaign?.campaignImages?.[0]?.name}
                    />
                </div>
            </OverlayTrigger>
        </NavLink>
    );
}
